import React, { useEffect, useState } from "react";
import useStore from "../../../../context/useStore";
import dataService from "../../../../helpers/dataService";
import tools from "../../../../helpers/tools";
import Loader from "../../../common/Loader";
import Table from "../../../common/Table";
import DownloadARDoc from "./DownloadARDoc";

const EPARList = ({ epData }) => {
  const [state] = useStore();
  const [isLoading, setIsLoading] = useState(false);
  const constants = state.constants.items;
  const [arList, setArList] = useState([]);
  useEffect(() => {
    getArList();
  }, []);

  const getArList = () => {
    setIsLoading(true);
    dataService.get(
      `eps/${epData.id}/lister-courriers`,
      setArList,
      (err) => {},
      () => setIsLoading(false),
    );
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Table
          fullWidth
          fields={[
            {
              path: "userRecipient",
              name: "Allocataire",
              render: (el) => {
                var recipientRoute =
                  el.model == "UserRecipient"
                    ? "recipients"
                    : el.model == "UserRecipientDSP"
                      ? "recipients-temp"
                      : "recipients-ep";
                return (
                  <a
                    target="_BLANK"
                    href={`/${recipientRoute}/${el.id}`}
                    className="btn btn-link text-left"
                  >
                    {tools.getFullname(el)}
                    <div>{el.nir}</div>
                  </a>
                );
              },
            },
            {
              path: "*",
              name: "Convocation EP",
              render: (el) =>
                el.inscriptionEp.type === "SUSPENSION" ? (
                  "—"
                ) : (
                  <DownloadARDoc
                    elem={el}
                    docData={el.convocation}
                    epBeginAt={epData.beginAt}
                    isV2={epData.version === 2}
                  />
                ),
            },
            {
              path: "*",
              name: "Notification de décision",
              render: (el) => {
                const isV2 = epData.version === 2;
                const estEnvoyee = !!el.notification?.historics.length;

                if (
                  !estEnvoyee &&
                  el.inscriptionEp.directorDecision === "A_SURSEOIR"
                ) {
                  return "NC - A SURSEOIR";
                }
                // Tant que la notification n'est pas partie, l'agent peut
                // contrôler ce qui partira, à condition qu'une décision finale
                // soit rendue : sans elle, il n'y a rien à prévisualiser.
                return estEnvoyee ||
                  (isV2 && el.inscriptionEp.hasFinalDecision) ? (
                  <DownloadARDoc
                    elem={el}
                    docData={el.notification}
                    isV2={isV2}
                  />
                ) : (
                  "Notification non envoyée"
                );
              },
            },
          ]}
          datas={arList}
        />
      )}
    </>
  );
};

export default EPARList;
